// Pilot
// export const API_URL = "https://cxyxjknf19.execute-api.us-west-2.amazonaws.com/PilotMode"

// Live
export const API_URL = "https://ocoruysjl5.execute-api.ap-south-1.amazonaws.com/LiveMode"

// Local
//  export const API_URL = "http://localhost:3000"

export const DarkModePrimaryColor = "#F5141F";
// Please turn off for no banner as "false"
export const showBanner = false;

